import { render, staticRenderFns } from "./work-collect.vue?vue&type=template&id=10c79e19&scoped=true"
import script from "./work-collect.vue?vue&type=script&lang=js"
export * from "./work-collect.vue?vue&type=script&lang=js"
import style0 from "./work-collect.vue?vue&type=style&index=0&id=10c79e19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c79e19",
  null
  
)

export default component.exports